/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateDeviceManagementApiKeyRequest = {
    apiKey: string;
    entityId: string;
    entityType: CreateDeviceManagementApiKeyRequest.entityType;
};
export namespace CreateDeviceManagementApiKeyRequest {
    export enum entityType {
        SHOP = 'SHOP',
        FINANCIER = 'FINANCIER',
    }
}

